import React, { useEffect, useState } from "react";
import { database, ref, push, onValue, remove, set, update } from './firebase';


const products = [
  "Premium 2 Litre Bottle",
  "Premium 1 Litre Bottle",
  "Premium 500ML Bottle",
  "Premium 250ML Bottle",
  "Green 1 Litre Bottle",
  "Green 500ML Bottle",
  "250ML Pouch",
  "20 Litre Jar",
  "Cool Jar",
  "Packed Ice Cube (500 gm)"
];

export default function OwnerManagerDashboard({ role }) {
  const [stock, setStock] = useState({});
  const [topSelling, setTopSelling] = useState([]);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    const prodRef = ref(database, "production");
    const invoiceRef = ref(database, "invoices");

    let productionMap = {};
    let billingMap = {};

    const calculateStock = () => {
      const result = {};
      products.forEach(product => {
        const produced = productionMap[product] || 0;
        const billed = billingMap[product] || 0;
        result[product] = produced - billed;
      });
      setStock(result);
    };

    const calculateTopSelling = () => {
      const now = new Date();
      let filteredBilling = {};

      Object.entries(billingMap).forEach(([product, entries]) => {
        filteredBilling[product] = 0;
        entries.forEach(entry => {
          const invoiceDate = new Date(entry.date);
          const sameMonth = invoiceDate.getMonth() === now.getMonth() && invoiceDate.getFullYear() === now.getFullYear();
          const sameWeek = now - invoiceDate < 7 * 24 * 60 * 60 * 1000;

          if (filter === "month" && sameMonth) filteredBilling[product] += entry.quantity;
          else if (filter === "week" && sameWeek) filteredBilling[product] += entry.quantity;
          else if (filter === "all") filteredBilling[product] += entry.quantity;
        });
      });

      const sorted = Object.entries(filteredBilling).sort((a, b) => b[1] - a[1]);
      setTopSelling(sorted);
    };

    onValue(prodRef, (snap) => {
      const data = snap.val() || {};
      productionMap = {};
      Object.values(data).forEach(entry => {
        entry.items.forEach(item => {
          productionMap[item.product] = (productionMap[item.product] || 0) + (item.quantity || 0);
        });
      });
      calculateStock();
    });

    onValue(invoiceRef, (snap) => {
      const data = snap.val() || {};
      billingMap = {};
      Object.values(data).forEach(invoice => {
        invoice.items.forEach(item => {
          if (!billingMap[item.product]) billingMap[item.product] = [];
          billingMap[item.product].push({ quantity: item.quantity || 0, date: invoice.date });
        });
      });
      calculateStock();
      calculateTopSelling();
    });
  }, [filter]);

  if (role !== "owner" && role !== "manager") return <p></p>;

  return (
    <div style={{ padding: 20, maxWidth: 800, margin: "auto" }}>
      <h2>{role === "owner" ? "Owner" : "Manager"} Dashboard</h2>
      <h3>Current Product Stock</h3>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ backgroundColor: "#f0f0f0" }}>
            <th style={{ border: "1px solid #ccc", padding: 8 }}>Product</th>
            <th style={{ border: "1px solid #ccc", padding: 8 }}>Stock Left</th>
          </tr>
        </thead>
        <tbody>
          {products.map(product => (
            <tr key={product}>
              <td style={{ border: "1px solid #ccc", padding: 8 }}>{product}</td>
              <td style={{ border: "1px solid #ccc", padding: 8 }}>
                {stock[product] !== undefined ? stock[product] : "Calculating..."}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {role === "owner" && (
        <>
          <h3 style={{ marginTop: 30 }}>Top Selling Products</h3>
          <div style={{ marginBottom: 10 }}>
            <label>Filter by: </label>
            <select value={filter} onChange={(e) => setFilter(e.target.value)}>
              <option value="all">All Time</option>
              <option value="month">This Month</option>
              <option value="week">This Week</option>
            </select>
          </div>
          <ol>
            {topSelling.map(([product, quantity], index) => (
              <li key={index}>{product} - {quantity} sold</li>
            ))}
          </ol>
        </>
      )}
    </div>
  );
}
